{
  "name": "@ns/company-bank-verify",
  "version": "1.0.0",
  "description": "Verify the reference sent to your bank account by nodeStream",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
